import { render, staticRenderFns } from "./ShareLinkCopyComponent.vue?vue&type=template&id=56e23bca&scoped=true"
import script from "./ShareLinkCopyComponent.vue?vue&type=script&lang=js"
export * from "./ShareLinkCopyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e23bca",
  null
  
)

export default component.exports